import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export default () => ({
    init() {
        const swiper = new Swiper(this.$root.querySelector('.media-testimonials-swiper'), {
            modules: [Autoplay],
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
        });
    }
});
